import React, { useEffect } from 'react';
import { Container, Row, Col } from 'reactstrap';
import styles from './Style.module.css';

const StayCalm = () => {
  const image = Math.floor(Math.random() * 7).toString();

  useEffect(() => {
    const images = [0, 1, 2, 3, 4, 5, 6];
    cacheImage(images);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const cacheImage = async (images) => {
    const promises = await images.map((n) => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = require(`assets/img/calm-gifs/breathe${n}.gif`).default;
        img.onload = resolve();
        img.onerror = reject();
      });
    });
    await Promise.all(promises);
  };

  return (
    <>
      <Container className={styles.page_bg} fluid={true}>
        <Row>
          <Col xs>
            <h1 className={`display-1 ${styles.text}`}>
              Stay Calm & Be Productive
            </h1>
          </Col>
        </Row>
        <Row className={styles.img_row}>
          <Col xs style={{ alignSelf: 'center' }}>
            <img
              alt="..."
              src={
                require(`assets/img/calm-gifs/breathe${image}.gif`).default
              }
            />
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default StayCalm;
